import { render, staticRenderFns } from "./ScForm.vue?vue&type=template&id=2a7ed848&"
import script from "./ScForm.vue?vue&type=script&lang=js&"
export * from "./ScForm.vue?vue&type=script&lang=js&"
import style0 from "./ScForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports